import React, { useEffect, useState } from 'react';

function LiquorCategory({ token, selectedPropertyId }) {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ name: '' });
  const resolvePropertyId = () => String(selectedPropertyId || localStorage.getItem('selectedPropertyId') || '').trim();
  const authHeaders = (extra = {}) => ({ Authorization: `Bearer ${token}`, 'x-property-id': resolvePropertyId(), ...extra });

  useEffect(() => {
    if (!resolvePropertyId()) {
      setCategories([]);
      setError('Select a property first from Hotel Config');
      return;
    }
    setError('');
    loadCategories();
  }, [token, selectedPropertyId]);

  const loadCategories = () => {
    if (!resolvePropertyId()) {
      setCategories([]);
      setError('Select a property first from Hotel Config');
      return;
    }
    fetch('/api/liquor-category', {
      headers: authHeaders()
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setCategories(data);
        } else if (data && Array.isArray(data.categories)) {
          setCategories(data.categories);
        } else {
          setCategories([]);
        }
      })
      .catch(() => {
        setError('Failed to load categories');
        setCategories([]);
      });
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCreate = async () => {
    try {
      if (!resolvePropertyId()) {
        setError('Select a property first from Hotel Config');
        return;
      }
      if (!form.name) {
        setError('Category name required');
        return;
      }
      const res = await fetch('/api/liquor-category', {
        method: 'POST',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (res.ok) {
        setCategories([...categories, data]);
        setForm({ name: '' });
        setError('');
      } else {
        setError(data.error || 'Create failed');
      }
    } catch (err) {
      setError('Network error: ' + err.message);
    }
  };

  const handleEdit = category => {
    setEditingId(category.id);
    setForm({ name: category.name });
  };

  const handleUpdate = async () => {
    try {
      if (!resolvePropertyId()) {
        setError('Select a property first from Hotel Config');
        return;
      }
      if (!form.name) {
        setError('Category name required');
        return;
      }
      const res = await fetch(`/api/liquor-category/${editingId}`, {
        method: 'PUT',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (res.ok) {
        setCategories(categories.map(c => c.id === editingId ? data : c));
        setForm({ name: '' });
        setEditingId(null);
        setError('');
      } else {
        setError(data.error || 'Update failed');
      }
    } catch (err) {
      setError('Network error: ' + err.message);
    }
  };

  const handleCancel = () => {
    setEditingId(null);
    setForm({ name: '' });
  };

  const handleDelete = async id => {
    try {
      if (!resolvePropertyId()) {
        setError('Select a property first from Hotel Config');
        return;
      }
      const res = await fetch(`/api/liquor-category/${id}`, {
        method: 'DELETE',
        headers: authHeaders()
      });
      const data = await res.json();
      if (res.ok) {
        setCategories(categories.filter(c => c.id !== id));
        setError('');
      } else {
        setError(data.error || 'Delete failed');
      }
    } catch (err) {
      setError('Network error: ' + err.message);
    }
  };

  return (
    <div className="page-shell">
      <h2 style={{color:'var(--theme-primary-dark)'}}>Liquor Categories</h2>
      {error && <div className="error-banner">{error}</div>}
      <div className="filter-bar" style={{marginBottom:'2rem'}}>
        <h3>{editingId ? 'Edit Category' : 'Add New Category'}</h3>
        <form style={{display:'grid',gap:'1rem'}}>
          <input name="name" placeholder="Category Name" value={form.name} onChange={handleChange} style={{padding:'0.75rem',borderRadius:'6px',border:'1px solid #dcdde1',maxWidth:'300px'}} />
        </form>
        <div style={{marginTop:'1rem',display:'flex',gap:'1rem'}}>
          {editingId ? (
            <>
              <button type="button" onClick={handleUpdate} className="btn-success" style={{padding:'0.75rem 2rem',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'1rem'}}>Update Category</button>
              <button type="button" onClick={handleCancel} className="btn-muted" style={{padding:'0.75rem 2rem',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'1rem'}}>Cancel</button>
            </>
          ) : (
            <button type="button" onClick={handleCreate} className="btn-primary" style={{padding:'0.75rem 2rem',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'1rem'}}>Add Category</button>
          )}
        </div>
      </div>
      <h3>Categories List</h3>
      {!categories || categories.length === 0 ? (
        <p>No categories found</p>
      ) : (
        <table style={{width:'100%',borderCollapse:'collapse',background:'#fff'}}>
          <thead>
            <tr style={{background:'var(--theme-primary-dark)',color:'#fff'}}>
              <th style={{padding:'0.75rem',textAlign:'left',borderBottom:'2px solid #dcdde1'}}>Category Name</th>
              <th style={{padding:'0.75rem',textAlign:'left',borderBottom:'2px solid #dcdde1'}}>Action</th>
            </tr>
          </thead>
          <tbody>
            {categories.map(category => (
              <tr key={category.id} style={{borderBottom:'1px solid #dcdde1'}}>
                <td style={{padding:'0.75rem'}}>{category.name}</td>
                <td style={{padding:'0.75rem',display:'flex',gap:'0.5rem'}}>
                  <button onClick={() => handleEdit(category)} style={{background:'#3498db',color:'#fff',border:'none',padding:'0.5rem 1rem',borderRadius:'4px',cursor:'pointer'}}>Edit</button>
                  <button onClick={() => handleDelete(category.id)} className="btn-danger" style={{border:'none',padding:'0.5rem 1rem',borderRadius:'4px',cursor:'pointer'}}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default LiquorCategory;
